<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Advanced Search',
      },
      {
        header: 'Search Settings',
        body: [
          `The filters allow the user to select a person type and select 
          the records to search in. The Advanced Search allows the 
          user to search the master record database, the history 
          table, or the submission records. The match method is 
          SQL. The Advanced Search does not access the matching engine.`,
        ],
      },
      {
        header: 'Search Parameters',
        body: [
          `Select the search parameters. The available fields are listed in the dropdown menu. 
          The Advanced Search will look in the selected field for the search term entered. Next, 
          select the comparison operator such as contains, starts with, ends with or is (exact). 
          Finally, enter the search term.The user may enter additional parameters by clicking the 
          Add New Parameter link. When all parameters have been selected, click Search.`,
        ],
      },
      {
        header: 'Search Results',
        body: [
          `The Search Results panel will list up to 2000 of the most recent records which match the search criteria.
           The user may drill into the Person Profile for any of the search results using the actions icon.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
